<template>
  <a-checkbox-group v-model:value="tagComputed">
    <a-checkbox v-for="item in options" :value="item.label">
      <a-tag :color="item.value">{{ item.label }}</a-tag>
    </a-checkbox>
  </a-checkbox-group>
</template>
<script setup lang="ts">
import { computed } from 'vue'
const props = defineProps<{
  value: GoodTag[]
}>()
const emit = defineEmits(['update:value'])

const tagComputed = computed({
  get() { return props.value.map(a => a.name) },
  set(names) {
    const data = names.map(name => {
      const item = options.value.first((item: any) => item.label === name)
      const color = item?.value ?? '#2e9a92'
      const isRequire = item?.meta ?? false
      return { name, color, isRequire }
    })
    emit('update:value', data)
  }
})
const options = computed(() => {
  const arr = JSON.parse($app.dic?.goodTag.info ?? '[]') as GoodTag[]
  return arr.map((a: GoodTag) => ({ label: a.name, value: a.color, meta: a.isRequire }))
})
</script>